import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import Tooltip from "@material-ui/core/Tooltip";


export default class TransactionCustomer extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		prefix: PropTypes.string,
		locations: PropTypes.array.isRequired,
		history: PropTypes.object.isRequired,
		afterCustomerSave: PropTypes.func.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			customerAddModalOpen: false,
			customerEditModalOpen: false,
		}
	}

	handleToggleCustomerAddModal = () => this.setState({customerAddModalOpen: !this.state.customerAddModalOpen})
	handleToggleCustomerEditModal = () => this.setState({customerEditModalOpen: !this.state.customerEditModalOpen})

	render() {

		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		let {properties, shouldLoad, afterCustomerSave, onSelectUpdate, onTextUpdate} = this.props;
		let {customerAddModalOpen, customerEditModalOpen} = this.state;
		let prefix = typeof this.props.prefix !== 'undefined' ? this.props.prefix : 'customer_';
		return (
			<div>
				<div className={'form-group'}>
					<div className="row">
						<div className="col-3">
							<span className="input-label">Customer</span>
							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								name={"Customer"}
								object={Objects.CustomerAdd}
								showModal={customerAddModalOpen}
								handleToggle={this.handleToggleCustomerAddModal}
								afterSave={afterCustomerSave}
								url={'customers'}
							/>
							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								id={object.customer}
								binary_id={object.customer_binary_id}
								name={"Customer"}
								object={Objects.CustomerEdit}
								objectProps={{
									object: object.customers
								}}
								showModal={customerEditModalOpen}
								handleToggle={this.handleToggleCustomerEditModal}
								afterSave={afterCustomerSave}
								size={"xl"}
								url={'customers'}
							/>
						</div>
						<div className="col-9 d-flex">
							<Button data-id={'add-customer'} onClick={this.handleToggleCustomerAddModal} className={"select-add"}
							        size={"sm"} outline color="primary">
								<i className={"fa fa-plus"}/>
							</Button>
							{object.customer &&
							<Button data-id={'edit-customer'} onClick={this.handleToggleCustomerEditModal} className={"select-add"}
							        size={"sm"} outline color="green-meadow">
								<i className={"fa fa-pencil"}/>
							</Button>}
							{object.customer &&
							<Tooltip title="Customer Identification" aria-label="Customer Identification">
								<Button onClick={() => this.props.history.push('/customers/' + object.customer_binary_id + '-' + object.customer + '#identification')}
								        className={"select-add"}
								        size={"sm"} outline color="secondary">
									<i className={"fa fa-id-card-o"}/>
								</Button>
							</Tooltip>}
							<div className={'flex-grow-1'} data-id={'my-customer'}>
								<Framework.Elements.Select
									shouldLoad={shouldLoad}
									update={onSelectUpdate}
									property={properties.customer}
									value={object.customer}
									binary_id={object.customer_binary_id}
									error={object.customer_error}
									object={object.customers}
									text={'name_first&name_last&name_suffix'}
									textHelper={'address/number'}
									sort={'name_first|name_last|name_suffix'}
									nullable={true}
									disabled={this.props.isCancelled}
								/>
							</div>
						</div>
					</div>
				</div>
				<p style={{
					color: "gray",
					padding: "0 4px",
					marginBottom: "19px",
					fontSize: "11px",
					lineHeight: '12px'
				}}>
					The customer name and address are stored with the transaction to
					preserve past Bound Book records in the event the customers name
					changes or they move to a new address.
				</p>

				<Parts.CustomerName
					object={object}
					properties={properties}
					onTextUpdate={onTextUpdate}
					prefix={prefix}
					disableFields={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
				/>
				<Parts.Address
					object={object}
					properties={properties}
					onTextUpdate={onTextUpdate}
					onSelectUpdate={onSelectUpdate}
					prefix={prefix}
					disableFields={typeof this.props.disableFields !== 'undefined' ? this.props.disableFields : false}
				/>
			</div>
		);
	}
}

